import { compose } from 'lodash/fp'
import { withTranslation } from 'react-i18next'
import { RoomServiceType, RoomType } from '../../../models/Room'
import withReduxCreate, {
  withCreateInitialValues,
} from '../CreateRoom/formCreate'
import CreateRoom from './CreateRoom'
import withReduxUpdate, { withUpdateInitialValues } from './formUpdate'

export enum FormNames {
  Create = 'create_room',
  Update = 'update_room',
}

export default {
  Create: compose(
    withCreateInitialValues,
    withReduxCreate(FormNames.Create),
    withTranslation(),
  )(CreateRoom),
  Update: compose(
    withUpdateInitialValues,
    withReduxUpdate(FormNames.Update),
    withTranslation(),
  )(CreateRoom),
}

export interface IFormValues {
  id?: string
  name?: string
  type?: RoomType
  description?: string
  title: string
  widget?: number
  roomSize?: number
  additionalBeds?: number
  additionalEquipment?: any
  size?: any
  id_country?: number
  coords_lat?: string
  coords_lng?: string
  street?: string
  googleMapGeocoding?: string
  post_code?: string
  city?: string
  singleBed?: number
  doubleBed?: number
  serviceCleaning?: Date | string | undefined
  serviceBedding?: Date | string | undefined
  serviceTowels?: Date | string | undefined
  serviceCleaningStage?: RoomServiceType
  customColor?: string
  position?: number
  syncFits?: string | boolean
  dontClose?: boolean

}
